import React from 'react'

import style from './MyhouseRegisterRestrictCountOverPopup.module.scss'

import { MYHOUSE_MAX_COUNT } from '@Root/contants/myhouseRegister'

type Props = {
  showPopup: any
  onButtonClick: any
}

const MyhouseRegisterRestrictCountOverPopup: React.FC<Props> = ({ showPopup, onButtonClick }: Props) => {
  return (
    <div className={`dimmed ${style['type_myhouse']}`} aria-hidden={showPopup ? 'false' : 'true'}>
      <div className={`${style['myhouse_popup']} ${style['type_complete']}`}>
        <div className={style.myhouse_popup_inner}>
          <strong>
            <h3 className={style.myhouse_popup_title}>우리집을 추가할 수 없습니다.</h3>
            <p className={style.myhouse_popup_text}>우리집은 최대 {MYHOUSE_MAX_COUNT}개까지 등록할 수 있습니다. 새로운 집을 추가하려면 기존의 집 주소를 삭제 후 등록해 주세요.</p>
          </strong>
        </div>
        <button className={style.myhouse_popup_close} type="button" onClick={onButtonClick}>
          확인
        </button>
      </div>
    </div>
  )
}

export default MyhouseRegisterRestrictCountOverPopup
